import { FC } from 'react';
import { useFormik, FormikProvider, Form, FormikConfig } from 'formik';

import { i18n as I18n } from '../../../utils/i18n';

import Field from '../../fields/field';
import Textbox from '../../fields/textbox';
import Checkbox from '../../fields/checkbox';

import { getValidator } from '../../../validators/login';

interface Values {
  email: string;
  password: string;
  rememberMe?: boolean;
}

type OnSubmit = FormikConfig<Values>['onSubmit'];

interface Props {
  initialValues?: Values;
  onSubmit: OnSubmit;
  showRememberMe?: boolean;
}

const LoginForm: FC<Props> = ({
  initialValues = { email: '', password: '', rememberMe: false },
  onSubmit,
  showRememberMe = true,
  ...props
}) => {
  const formik = useFormik<Values>({
    initialValues,
    onSubmit,
    validate: getValidator(),
    validateOnMount: true,
  });

  const { errors, touched, isValid } = formik;

  return (
    <FormikProvider value={formik}>
      <Form {...props}>
        <div className="field__input field__input--placeholder">
          <Field
            as={Textbox}
            type="email"
            label={I18n.t('sign_in.email.label')}
            name="email"
            placeholder={I18n.t('sign_in.email.label')}
            error={touched.email && !!errors.email}
            errorMsg={errors.email}
          />
        </div>

        <div className="field__input field__input--placeholder">
          <Field
            as={Textbox}
            type="password"
            label={I18n.t('sign_in.password.label')}
            name="password"
            placeholder={I18n.t('sign_in.password.label')}
            error={touched.password && !!errors.password}
            errorMsg={errors.password}
          />
        </div>

        {showRememberMe && (
          <div className="field__checkbox">
            <Field
              as={Checkbox}
              type="checkbox"
              label={I18n.t('sign_in.remember_me')}
              name="rememberMe"
            />
          </div>
        )}

        <p>
          <input
            className="button button--secondary button--block"
            type="submit"
            disabled={!isValid}
            value={I18n.t('sign_in.sign_in')}
          />
        </p>
      </Form>
    </FormikProvider>
  );
};

export default LoginForm;
